export default __webpack_public_path__ + "static/media/noa-26.7d283425.jpg";